namespace appn.views.reports.index {
    class InitArgs {
        reportsIndex: string = emptyString;
    }

    let _initArgs: InitArgs;
    let _dataTable: any = null;

    export function init(args: InitArgs): void {
        _initArgs = args;

        appn.folderFilter.init(_initArgs.reportsIndex);
        createDataTable();
    }

    function createDataTable() {
        _dataTable = appn.dataTable.create('.dataTable', {
            sAjaxSource: 'Reports/DataTable',
            fnServerData: function (data: any) {
                // Provide folder filter param positionally like other pages (not used server-side yet)
                data.push({ name: 'sCustom_1', value: appn.folderFilter.getStateOrDefault().value });
            },
            autoWidth: false,
            aaSorting: [[1, 'asc']],
            aoColumns: [
                { bSortable: false, sWidth: '3%' },
                { bSortable: true, sWidth: '60%' },
                { bSortable: true, sWidth: '20%' },
                { bSortable: true, sWidth: '17%' }
            ],
            fnInitComplete: function () {
                // Inject Show button into filter area and add placeholder like other pages
                appn.sideFilterAndContent.appendShowButton($('#DataTables_Table_0_filter'));
                appn.dataTable.addSearchPlaceholder(T('Filter results where the Reports <b>Name or Type</b> contains a keyword typed in here.'));
            }
        });
    }
}
